import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import './AnalyseDataPage.css'

export default function AnalyseDataPage() {
  const [activeTab, setActiveTab] = useState('generalistes')
  const [selectedUseCase, setSelectedUseCase] = useState('none')
  const [selectedIA, setSelectedIA] = useState('none')
  const chartRefs = {
    complexityImpact: useRef(null),
    radarSkills: useRef(null)
  }

  // Données enrichies et restructurées
  const iaGeneralistes = [
    {
      id: 'chatgpt',
      name: 'ChatGPT (OpenAI)',
      polyvalence: 'Très élevée',
      pointFort: 'Outil le plus transversal',
      environnement: 'Entreprises multi-usages',
      prix: 'Plus de 20$/mois',
      forfaits: [
        { nom: 'Gratuit', prix: '0$', description: 'Accès limité à GPT-4o mini, restrictions d\'usage' },
        { nom: 'Plus', prix: '20$/mois', description: 'GPT-4o, DALL-E 3, navigation web, analyse de fichiers' },
        { nom: 'Team', prix: '25$/utilisateur/mois', description: 'Gestion d\'équipe, admin console, données sécurisées' },
        { nom: 'Enterprise', prix: 'Sur devis', description: 'SSO, conformité avancée, support prioritaire, API illimitée' }
      ],
      description: 'Assistant le plus polyvalent pour un usage général en entreprise grâce à son large écosystème, ses usages en rédaction, code, analyse, agents automatisés et génération d\'images.',
      usageIdeal: 'Entreprises qui cherchent un outil unique capable de couvrir plusieurs besoins métiers sans multiplier les solutions.',
      avantages: [
        'Polyvalence maximale - couvre rédaction, code, analyse, images',
        'Écosystème très riche avec plugins et intégrations',
        'Large communauté et documentation abondante',
        'Performance équilibrée sur tous les types de tâches',
        'Intégration DALL-E 3 pour la génération d\'images'
      ],
      inconvenients: [
        'Données stockées sur serveurs américains (RGPD)',
        'Coût peut être élevé pour les usages intensifs',
        'Fenêtre de contexte limitée par rapport à Claude',
        'Dépendance à un seul fournisseur américain'
      ]
    },
    {
      id: 'claude',
      name: 'Claude (Anthropic)',
      polyvalence: 'Élevée',
      pointFort: 'Documents longs, rédaction, code',
      environnement: 'Juridique, R&D, analyse',
      prix: 'Offre payante autour de 20$/mois',
      forfaits: [
        { nom: 'Gratuit', prix: '0$', description: 'Claude 3 Haiku, usage limité, priorité basse' },
        { nom: 'Pro', prix: '20$/mois', description: 'Claude 3.5 Sonnet, priorité élevée, fichiers illimités' },
        { nom: 'Team', prix: '30$/utilisateur/mois', description: 'Admin console, usage accru, support prioritaire' },
        { nom: 'Enterprise', prix: 'Sur devis', description: 'SSO, conformité avancée, données isolées, API entreprise' }
      ],
      description: 'Particulièrement fort pour la rédaction de qualité, l\'analyse de longs documents et l\'assistance au développement, avec une très grande fenêtre de contexte.',
      usageIdeal: 'Tâches demandant rigueur, nuance et compréhension fine du texte. Idéal pour les équipes juridiques, financières, RH ou techniques.',
      avantages: [
        'Fenêtre de contexte exceptionnelle (200K+ tokens)',
        'Style d\'écriture naturel et nuancé',
        'Excellent pour l\'analyse de documents longs',
        'Approche constitutionnelle plus sûre',
        'Performance supérieure en rédaction de qualité'
      ],
      inconvenients: [
        'Moins d\'intégrations natives que ChatGPT',
        'Pas de génération d\'images native',
        'Écosystème de plugins plus limité',
        'Moins adapté aux tâches très techniques'
      ]
    },
    {
      id: 'gemini',
      name: 'Gemini (Google)',
      polyvalence: 'Élevée',
      pointFort: 'Multimodalité, Google Workspace',
      environnement: 'Organisations sur Google',
      prix: 'AI Pro à 19,99$/mois',
      forfaits: [
        { nom: 'Gratuit', prix: '0$', description: 'Gemini Flash, usage limité, publicité Google' },
        { nom: 'AI Premium', prix: '19,99$/mois', description: 'Gemini Ultra, 2TB Google One, intégration Workspace complète' },
        { nom: 'Business', prix: '20$/utilisateur/mois', description: 'Intégration Workspace Enterprise, sécurité avancée' },
        { nom: 'Enterprise', prix: 'Sur devis', description: 'Conformité avancée, support 24/7, API Vertex AI' }
      ],
      description: 'Se distingue par sa multimodalité native et son intégration à l\'écosystème Google, notamment Gmail, Docs, Sheets et Meet.',
      usageIdeal: 'Entreprises déjà très équipées en Google Workspace pour la recherche, la synthèse, la collaboration et l\'automatisation documentaire.',
      avantages: [
        'Intégration native Google Workspace parfaite',
        'Multimodalité native (texte, image, vidéo, audio)',
        'Accès en temps réel au web pour les recherches',
        'Vitesse d\'exécution très rapide',
        'Écosystème Google déjà présent dans beaucoup d\'entreprises'
      ],
      inconvenients: [
        'Dépendance à l\'écosystème Google',
        'Moins précis sur les tâches de code complexe',
        'Données stockées sur serveurs Google',
        'Fenêtre de contexte variable selon le modèle'
      ]
    },
    {
      id: 'copilot',
      name: 'Microsoft 365 Copilot',
      polyvalence: 'Élevée',
      pointFort: 'Intégration native Microsoft',
      environnement: 'Entreprises sur Microsoft 365',
      prix: '30$/utilisateur/mois',
      forfaits: [
        { nom: 'Copilot Pro', prix: '20$/mois', description: 'Accès individuel, intégration Office 365 standard' },
        { nom: 'Copilot for Microsoft 365', prix: '30$/utilisateur/mois', description: 'Intégration complète Teams, Word, Excel, PowerPoint, Outlook' },
        { nom: 'Copilot for Sales', prix: '50$/utilisateur/mois', description: 'Intégration Dynamics 365, CRM avancé' },
        { nom: 'Enterprise', prix: 'Sur devis', description: 'Déploiement personnalisé, conformité avancée, support dédié' }
      ],
      description: 'Conçu pour les organisations qui travaillent déjà dans Word, Excel, Outlook, Teams et SharePoint, avec une intégration directe aux données métier via Microsoft Graph.',
      usageIdeal: 'Entreprises où la priorité est l\'intégration native avec les outils quotidiens des collaborateurs.',
      avantages: [
        'Intégration parfaite avec l\'écosystème Microsoft 365',
        'Accès direct aux données métier via Microsoft Graph',
        'Adoption facilitée par les collaborateurs',
        'Sécurité et conformité Microsoft Enterprise',
        'Assistance directement dans les outils quotidiens'
      ],
      inconvenients: [
        'Coût élevé (30$/utilisateur/mois)',
        'Nécessite une infrastructure Microsoft 365 existante',
        'Dépendance totale à Microsoft',
        'Performance variable selon les applications'
      ]
    },
    {
      id: 'mistral',
      name: 'Mistral AI',
      polyvalence: 'Bonne',
      pointFort: 'Souveraineté, open source, coût',
      environnement: 'Secteurs régulés, hébergement maîtrisé',
      prix: '14,99€/mois',
      forfaits: [
        { nom: 'Le Chat Gratuit', prix: '0€', description: 'Mistral 7B, usage limité, priorité basse' },
        { nom: 'Le Chat Pro', prix: '14,99€/mois', description: 'Mistral Large, priorité élevée, contexte étendu' },
        { nom: 'Mistral Platform', prix: 'Sur utilisation', description: 'API payante au token, modèles Mistral Large/Medium' },
        { nom: 'Enterprise', prix: 'Sur devis', description: 'Déploiement on-premise, support dédié, SLA garanti' }
      ],
      description: 'Acteur européen avec positionnement fort sur la souveraineté, les modèles open source et les déploiements contrôlables pour les entreprises ayant des exigences de conformité élevées.',
      usageIdeal: 'Structures sensibles au budget et aux exigences de conformité, contexte français ou européen.',
      avantages: [
        'Souveraineté européenne - données hébergées en Europe',
        'Modèles open source disponibles',
        'Coût plus compétitif que les solutions américaines',
        'Déploiement on-premise possible',
        'Conformité RGPD native'
      ],
      inconvenients: [
        'Écosystème d\'intégrations plus limité',
        'Performance légèrement inférieure sur certaines tâches',
        'Moins de ressources communautaires',
        'Support technique moins étendu'
      ]
    }
  ]

  const iaSpecialisees = {
    image: {
      icon: '🎨',
      name: 'Génération d\'Images',
      desc: "Outils spécialisés dans la création visuelle pour le marketing, le prototypage et l'illustration.",
      tools: [
        { name: 'DALL·E 3', tag: 'Simple accès', desc: 'Intégré à ChatGPT, facile d\'accès pour les usages rapides et intégrés.' },
        { name: 'Midjourney', tag: 'Haute qualité', desc: 'Souvent préféré pour la qualité artistique et photoréaliste.' },
        { name: 'Adobe Firefly', tag: 'Licences claires', desc: 'Particulièrement rassurant pour les usages marketing et créatifs nécessitant un cadre de licences clair.' }
      ]
    },
    video: {
      icon: '🎬',
      name: 'Vidéo et Formation',
      desc: "Solutions adaptées aux contenus de formation, communication interne et support client vidéo.",
      tools: [
        { name: 'Synthesia', tag: 'Avatars', desc: 'Particulièrement adapté aux contenus de formation avec avatars et traductions.' },
        { name: 'HeyGen', tag: 'Automatisation', desc: 'Spécialisé dans l\'automatisation de la production vidéo pour communication interne.' },
        { name: 'Runway', tag: 'Création visuelle', desc: 'Plus orienté création visuelle et production vidéo créative.' }
      ]
    },
    audio: {
      icon: '🎵',
      name: 'Audio et Musique',
      desc: "Outils pour la création de jingles, musiques de présentation et supports multimédias.",
      tools: [
        { name: 'Suno', tag: 'Musique complète', desc: 'Création de musiques complètes à partir de description textuelle.' },
        { name: 'Soundraw', tag: 'Jingles', desc: 'Spécialisé dans la création de jingles et musiques de présentation.' },
        { name: 'ElevenLabs', tag: 'Voix off', desc: 'Leader de la synthèse vocale pour voix off professionnelles.' }
      ]
    }
  }

  const solutionsLocales = [
    {
      name: 'Ollama',
      usage: 'Exécuter des LLM en local simplement',
      niveau: 'Faible à intermédiaire',
      cout: 'Gratuit',
      description: 'Permet de conserver les traitements sur les machines ou serveurs de l\'entreprise, réduisant l\'exposition des données sensibles.'
    },
    {
      name: 'LM Studio',
      usage: 'Interface graphique pour tester des modèles locaux',
      niveau: 'Faible',
      cout: 'Gratuit',
      description: 'Interface intuitive pour découvrir et tester différents modèles open source en local.'
    },
    {
      name: 'GPT4All',
      usage: 'Assistant local poste de travail',
      niveau: 'Faible',
      cout: 'Gratuit',
      description: 'Assistant complet fonctionnant directement sur poste de travail sans connexion internet.'
    },
    {
      name: 'Jan',
      usage: 'Alternative open source type assistant interne',
      niveau: 'Intermédiaire',
      cout: 'Gratuit',
      description: 'Solution open source alternative pour déploiement d\'assistant interne personnalisé.'
    },
    {
      name: 'OpenAI Enterprise (Azure)',
      usage: 'Déploiement Azure OpenAI avec isolation de données',
      niveau: 'Avancé',
      cout: 'Sur devis',
      description: 'Solution enterprise via Azure OpenAI Service avec isolation de données, conformité avancée et support Microsoft.'
    },
    {
      name: 'Anthropic Claude Enterprise',
      usage: 'Déploiement souverain avec isolation de données',
      niveau: 'Avancé',
      cout: 'Sur devis',
      description: 'Offre enterprise avec options de déploiement contrôlé, isolation de données et garanties de non-utilisation des données pour l\'entraînement.'
    },
    {
      name: 'Google Cloud Vertex AI',
      usage: 'Déploiement souverain avec régionalisation',
      niveau: 'Avancé',
      cout: 'Sur devis',
      description: 'Déploiement via Google Cloud avec options de régionalisation des données, conformité avancée et intégration écosystème Google.'
    },
    {
      name: 'Mistral Enterprise on-premise',
      usage: 'Déploiement souverain ou maîtrisé en entreprise',
      niveau: 'Avancé',
      cout: 'Sur devis',
      description: 'Solution enterprise pour déploiement souverain avec support et garanties de conformité, option on-premise disponible.'
    }
  ]

  const iaExcel = [
    {
      name: 'Microsoft Copilot',
      pointsForts: 'Formules, TCD, graphiques, nettoyage, résumés en langage naturel',
      integration: 'Native dans Excel',
      public: 'Collaborateurs métier',
      description: 'Solution la plus directement exploitable pour les équipes déjà équipées de Microsoft 365. Permet de demander en langage naturel la création de formules, analyses, graphiques.'
    },
    {
      name: 'ChatGPT',
      pointsForts: 'Formules, logique métier, VBA, explications',
      integration: 'Navigateur ou add-in',
      public: 'Utilisateurs polyvalents',
      description: 'Particulièrement utile comme assistant externe pour expliquer une formule, corriger une erreur, générer du VBA ou transformer une logique métier en formule Excel.'
    },
    {
      name: 'Claude',
      pointsForts: 'Analyse, reformulation, raisonnement sur cas complexes',
      integration: 'Navigateur',
      public: 'RH, finance, équipes support',
      description: 'Intéressant quand les demandes Excel s\'accompagnent d\'un fort besoin d\'explication et de reformulation métier.'
    },
    {
      name: 'Python dans Excel',
      pointsForts: 'Analyse avancée, automatisation experte',
      integration: 'Native dans Excel 365',
      public: 'Analystes et experts',
      description: 'Particulièrement utile pour les profils analystes voulant faire des traitements complexes avec pandas et analyses statistiques poussées.'
    }
  ]

  const recommandationsEntreprise = [
    {
      profil: 'PME généraliste',
      recommandation: 'ChatGPT',
      description: 'Souvent le meilleur point d\'entrée grâce à sa polyvalence et son coût modéré. Copilot devient prioritaire si l\'environnement Microsoft 365 est déjà au cœur des usages.',
      raisons: ['Polyvalence maximale', 'Coût modéré', 'Déploiement rapide', 'Multi-services']
    },
    {
      profil: 'Entreprise très orientée Excel et bureautique',
      recommandation: 'Microsoft 365 Copilot',
      description: 'Généralement le choix le plus cohérent pour maximiser l\'adoption par les collaborateurs en apportant l\'IA directement dans les outils existants.',
      raisons: ['Intégration native', 'Réduction friction usage', 'Adoption utilisateur', 'Écosystème Microsoft']
    },
    {
      profil: 'Secteur régulé ou sensible',
      recommandation: 'Modèle local ou maîtrisé',
      description: 'Approche à privilégier avec Mistral ou LLM open source déployé en interne via Ollama, LM Studio ou architecture serveur dédié.',
      raisons: ['Souveraineté', 'Confidentialité', 'Conformité', 'Contrôle infrastructure']
    }
  ]

  const classementPratique = [
    {
      categorie: 'IA la plus polyvalente',
      vainqueur: 'ChatGPT',
      description: 'Outil le plus polyvalent pour une entreprise qui veut une seule IA capable de couvrir la rédaction, l\'analyse, le code, les idées et la création de contenus variés.'
    },
    {
      categorie: 'IA la plus forte pour les documents et le raisonnement',
      vainqueur: 'Claude',
      description: 'Souvent la meilleure option lorsqu\'il faut comprendre de gros volumes de texte, produire des synthèses solides et assister des équipes sur des sujets complexes.'
    },
    {
      categorie: 'IA la plus forte pour Excel et les collaborateurs bureautiques',
      vainqueur: 'Microsoft 365 Copilot',
      description: 'Meilleur choix pour aider les collaborateurs au quotidien dans Excel et plus largement dans l\'environnement Microsoft.'
    },
    {
      categorie: 'IA la moins chère parmi les offres premium',
      vainqueur: 'Mistral',
      description: 'Propose l\'un des prix premium les plus bas parmi les assistants généralistes crédibles pour l\'entreprise, avec en plus un fort avantage sur la souveraineté.'
    },
    {
      categorie: 'IA la plus adaptée à la protection des données',
      vainqueur: 'Solutions locales/on-premise',
      description: 'Les plus pertinentes pour la protection maximale des données, notamment autour de Mistral, Ollama, LM Studio ou GPT4All selon le niveau technique disponible.'
    }
  ]

  const useCasesData = {
    synthesize: {
      title: "Synthèse de document long",
      tool: "Claude 3 (Anthropic)",
      why: "Claude possède une immense 'fenêtre de contexte'. Vous pouvez lui fournir un PDF de 100 pages, il le lira intégralement sans perdre de mémoire.",
      prompt: "« Agis comme un analyste expert. Voici un rapport [insérer doc]. Résume-le en 5 points clés à l'attention de la direction, puis dresse un tableau des risques et opportunités mentionnés. »"
    },
    email: {
      title: "Rédaction d'email délicat",
      tool: "ChatGPT (OpenAI)",
      why: "Excellent pour adapter le ton et la diplomatie. Il vous aide à structurer des messages difficiles sans émotion.",
      prompt: "« Rédige un email professionnel à mon prestataire. Il a 2 semaines de retard. Le ton doit être ferme mais diplomate, axé sur la recherche de solution. Ne sois pas agressif. »"
    },
    data: {
      title: "Analyse de données Excel",
      tool: "ChatGPT (Mode Advanced Data Analysis)",
      why: "Vous pouvez uploader directement un fichier CSV ou Excel. Il écrira des scripts en Python en arrière-plan pour nettoyer les données et générer des graphiques.",
      prompt: "« Voici les ventes de 2025. Identifie les 3 produits les plus rentables, détecte s'il y a une saisonnalité, et génère un graphique en barres des revenus par mois. »"
    },
    presentation: {
      title: "Structure de présentation",
      tool: "Gemini ou ChatGPT",
      why: "Très doués pour la structuration logique d'idées. Gemini est pratique si vous voulez exporter ensuite vers Google Slides.",
      prompt: "« Je dois faire une présentation de 15 minutes sur notre nouvelle stratégie RSE à des employés non techniques. Propose-moi un plan détaillé slide par slide (environ 10 slides), avec le message clé pour chacune. »"
    },
    code: {
      title: "Déboguer ou coder",
      tool: "Cursor (ou GitHub Copilot)",
      why: "Au lieu de copier/coller dans ChatGPT, Cursor lit tous les fichiers de votre projet en même temps et comprend comment ils interagissent.",
      prompt: "Dans l'éditeur (Ctrl+K) : « Crée une nouvelle route d'API pour l'authentification des utilisateurs en utilisant le middleware que nous avons défini dans auth.js. »"
    },
    image: {
      title: "Créer un visuel d'illustration",
      tool: "Midjourney ou DALL-E 3",
      why: "DALL-E pour les schémas/infographies, Midjourney pour des photos ultra-réalistes ou conceptuelles.",
      prompt: "« Photographie hyperréaliste, plan large, des employés diversifiés collaborant autour d'un grand écran interactif lumineux dans un bureau moderne et végétalisé, éclairage naturel, style corporate tech. »"
    }
  }

  useEffect(() => {
    // Load Chart.js
    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/chart.js'
    script.async = true
    document.body.appendChild(script)

    script.onload = () => {
      if (window.Chart) {
        initCharts()
      }
    }

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }
    }
  }, [])

  const initCharts = () => {
    if (chartRefs.complexityImpact.current && chartRefs.radarSkills.current) {
      // Matrice Complexité vs Impact (Scatter Plot)
      const complexityImpactData = {
        datasets: [
          {
            label: 'Quick Wins',
            data: [
              { x: 2, y: 9, label: 'Rédaction d\'emails' },
              { x: 3, y: 8, label: 'Synthèse de documents' },
              { x: 2, y: 7, label: 'Traduction rapide' },
              { x: 3, y: 8, label: 'Génération d\'idées' }
            ],
            backgroundColor: 'rgba(0, 255, 136, 0.8)',
            borderColor: 'rgba(0, 255, 136, 1)',
            pointRadius: 8,
            pointHoverRadius: 12
          },
          {
            label: 'Investissements Stratégiques',
            data: [
              { x: 7, y: 9, label: 'Analyse prédictive' },
              { x: 8, y: 8, label: 'Intégration API' },
              { x: 6, y: 7, label: 'Automatisation workflows' }
            ],
            backgroundColor: 'rgba(255, 149, 0, 0.8)',
            borderColor: 'rgba(255, 149, 0, 1)',
            pointRadius: 8,
            pointHoverRadius: 12
          },
          {
            label: 'Quick Fixes',
            data: [
              { x: 2, y: 3, label: 'Correction orthographe' },
              { x: 3, y: 4, label: 'Reformulation simple' }
            ],
            backgroundColor: 'rgba(100, 116, 139, 0.8)',
            borderColor: 'rgba(100, 116, 139, 1)',
            pointRadius: 8,
            pointHoverRadius: 12
          }
        ]
      }

      new window.Chart(chartRefs.complexityImpact.current, {
        type: 'scatter',
        data: complexityImpactData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top',
              labels: {
                color: 'rgba(255, 255, 255, 0.8)',
                usePointStyle: true,
                boxWidth: 8
              }
            },
            tooltip: {
              backgroundColor: 'rgba(10, 10, 10, 0.9)',
              titleColor: '#fff',
              bodyColor: '#fff',
              borderColor: 'rgba(0, 255, 136, 0.3)',
              borderWidth: 1,
              callbacks: {
                label: function(context) {
                  const point = context.raw
                  return `${point.label} (Complexité: ${point.x}/10, Impact: ${point.y}/10)`
                }
              }
            }
          },
          scales: {
            x: {
              title: {
                display: true,
                text: 'Complexité de mise en place',
                color: 'rgba(255, 255, 255, 0.6)',
                font: { size: 12 }
              },
              min: 0,
              max: 10,
              grid: { color: 'rgba(255, 255, 255, 0.1)' },
              ticks: { color: 'rgba(255, 255, 255, 0.6)' }
            },
            y: {
              title: {
                display: true,
                text: 'Impact / Gain de temps',
                color: 'rgba(255, 255, 255, 0.6)',
                font: { size: 12 }
              },
              min: 0,
              max: 10,
              grid: { color: 'rgba(255, 255, 255, 0.1)' },
              ticks: { color: 'rgba(255, 255, 255, 0.6)' }
            }
          }
        }
      })

      // Radar des Compétences IA
      new window.Chart(chartRefs.radarSkills.current, {
        type: 'radar',
        data: {
          labels: ['Raisonnement Logique', 'Créativité Rédactionnelle', 'Fenêtre de Contexte', 'Vitesse Exécution', 'Fiabilité Code'],
          datasets: [
            {
              label: 'GPT-4o',
              data: [9, 8, 7, 9, 9],
              backgroundColor: 'rgba(0, 255, 136, 0.2)',
              borderColor: 'rgba(0, 255, 136, 1)',
              borderWidth: 2,
              pointBackgroundColor: 'rgba(0, 255, 136, 1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(0, 255, 136, 1)'
            },
            {
              label: 'Claude 3.5',
              data: [8, 9, 10, 8, 8],
              backgroundColor: 'rgba(0, 170, 255, 0.2)',
              borderColor: 'rgba(0, 170, 255, 1)',
              borderWidth: 2,
              pointBackgroundColor: 'rgba(0, 170, 255, 1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(0, 170, 255, 1)'
            },
            {
              label: 'Gemini 1.5',
              data: [8, 7, 9, 10, 7],
              backgroundColor: 'rgba(255, 149, 0, 0.2)',
              borderColor: 'rgba(255, 149, 0, 1)',
              borderWidth: 2,
              pointBackgroundColor: 'rgba(255, 149, 0, 1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(255, 149, 0, 1)'
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            r: {
              beginAtZero: true,
              max: 10,
              grid: { color: 'rgba(255, 255, 255, 0.1)' },
              angleLines: { color: 'rgba(255, 255, 255, 0.1)' },
              pointLabels: {
                color: 'rgba(255, 255, 255, 0.8)',
                font: { size: 11 }
              },
              ticks: {
                color: 'rgba(255, 255, 255, 0.6)',
                backdropColor: 'transparent'
              }
            }
          },
          plugins: {
            legend: {
              display: true,
              position: 'top',
              labels: {
                color: 'rgba(255, 255, 255, 0.8)',
                usePointStyle: true,
                boxWidth: 8
              }
            },
            tooltip: {
              backgroundColor: 'rgba(10, 10, 10, 0.9)',
              titleColor: '#fff',
              bodyColor: '#fff',
              borderColor: 'rgba(0, 255, 136, 0.3)',
              borderWidth: 1
            }
          }
        }
      })
    }
  }

  const renderCategoryContent = () => {
    switch(activeTab) {
      case 'generalistes':
        return (
          <div className="category-content fade-in">
            <h3 className="category-title">
              <span className="category-icon">🤖</span>
              IA Généralistes
            </h3>
            <p className="category-desc">Les grands assistants généralistes qui couvrent la plupart des besoins métiers en entreprise.</p>
            <div className="ia-table-container">
              <table className="ia-comparison-table glass-card">
                <thead>
                  <tr>
                    <th>IA</th>
                    <th>Polyvalence</th>
                    <th>Point fort principal</th>
                    <th>Environnement idéal</th>
                    <th>Prix indicatif</th>
                  </tr>
                </thead>
                <tbody>
                  {iaGeneralistes.map((ia, index) => (
                    <tr key={index}>
                      <td className="ia-name-cell">
                        <strong>{ia.name}</strong>
                        <div className="ia-desc">{ia.description}</div>
                      </td>
                      <td className="polyvalence-cell">{ia.polyvalence}</td>
                      <td className="point-fort-cell">{ia.pointFort}</td>
                      <td className="environnement-cell">{ia.environnement}</td>
                      <td className="prix-cell">{ia.prix}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )
      
      case 'specialisees':
        return (
          <div className="category-content fade-in">
            <h3 className="category-title">
              <span className="category-icon">🎯</span>
              IA Spécialisées par Type de Contenu
            </h3>
            <p className="category-desc">Solutions spécialisées pour des besoins créatifs et multimédias spécifiques.</p>
            <div className="specialisees-grid">
              {Object.values(iaSpecialisees).map((categorie, index) => (
                <div key={index} className="specialisee-card glass-card">
                  <h4 className="specialisee-title">
                    <span className="specialisee-icon">{categorie.icon}</span>
                    {categorie.name}
                  </h4>
                  <p className="specialisee-desc">{categorie.desc}</p>
                  <div className="tools-list">
                    {categorie.tools.map((tool, toolIndex) => (
                      <div key={toolIndex} className="tool-item">
                        <span className="tool-name">{tool.name}</span>
                        <span className="tool-tag">{tool.tag}</span>
                        <p className="tool-description">{tool.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      
      case 'locales':
        return (
          <div className="category-content fade-in">
            <h3 className="category-title">
              <span className="category-icon">🔒</span>
              Solutions Locales et Souveraines
            </h3>
            <p className="category-desc">Pour les entreprises traitant des données sensibles nécessitant une maîtrise complète du cycle de vie des données. Les options enterprise/local sont disponibles chez OpenAI, Anthropic, Google et Mistral.</p>
            <div className="locales-section">
              <div className="locales-intro glass-card">
                <h4>Pourquoi une IA locale ?</h4>
                <p>Une IA locale permet de conserver les traitements sur les machines ou serveurs de l'entreprise, ce qui réduit l'exposition des données sensibles et facilite la gouvernance interne. Les grands fournisseurs (OpenAI, Anthropic, Google, Mistral) proposent tous des offres enterprise avec isolation de données.</p>
                <div className="avantages-grid">
                  <div className="avantage-item">
                    <span className="avantage-icon">🛡️</span>
                    <div>
                      <strong>Confidentialité</strong>
                      <p>Les données ne quittent pas l'environnement de l'entreprise</p>
                    </div>
                  </div>
                  <div className="avantage-item">
                    <span className="avantage-icon">🔧</span>
                    <div>
                      <strong>Contrôle</strong>
                      <p>Meilleur maîtrise de l'hébergement, des accès et de la conformité</p>
                    </div>
                  </div>
                  <div className="avantage-item">
                    <span className="avantage-icon">🌐</span>
                    <div>
                      <strong>Autonomie</strong>
                      <p>Usage possible en réseau interne, voire hors connexion</p>
                    </div>
                  </div>
                  <div className="avantage-item">
                    <span className="avantage-icon">💰</span>
                    <div>
                      <strong>Coûts prévisibles</strong>
                      <p>Évite les abonnements massifs par utilisateur</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="solutions-table-container">
                <table className="solutions-table glass-card">
                  <thead>
                    <tr>
                      <th>Solution</th>
                      <th>Usage principal</th>
                      <th>Niveau requis</th>
                      <th>Coût</th>
                    </tr>
                  </thead>
                  <tbody>
                    {solutionsLocales.map((solution, index) => (
                      <tr key={index}>
                        <td className="solution-name">
                          <strong>{solution.name}</strong>
                          <p>{solution.description}</p>
                        </td>
                        <td>{solution.usage}</td>
                        <td>{solution.niveau}</td>
                        <td>{solution.cout}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )
      
      case 'excel':
        return (
          <div className="category-content fade-in">
            <h3 className="category-title">
              <span className="category-icon">📊</span>
              IA Spécialisées Excel et Bureautique
            </h3>
            <p className="category-desc">Pour une entreprise travaillant énormément avec Excel, le choix de l'IA dépend de sa capacité à aider concrètement les collaborateurs.</p>
            <div className="excel-intro glass-card">
              <h4>Le critère décisif pour Excel</h4>
              <p>La capacité à aider les collaborateurs à nettoyer des données, créer des formules, produire des tableaux croisés, expliquer des erreurs et accélérer l'analyse.</p>
            </div>
            
            <div className="excel-table-container">
              <table className="excel-table glass-card">
                <thead>
                  <tr>
                    <th>Outil</th>
                    <th>Points forts sur Excel</th>
                    <th>Intégration</th>
                    <th>Public idéal</th>
                  </tr>
                </thead>
                <tbody>
                  {iaExcel.map((ia, index) => (
                    <tr key={index}>
                      <td className="excel-name-cell">
                        <strong>{ia.name}</strong>
                        <p>{ia.description}</p>
                      </td>
                      <td>{ia.pointsForts}</td>
                      <td>{ia.integration}</td>
                      <td>{ia.public}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )
      
      default:
        return null
    }
  }

  const renderUseCaseResult = () => {
    const caseData = useCasesData[selectedUseCase]
    if (!caseData) {
      return (
        <div className="use-case-placeholder">
          <span className="placeholder-icon">👈</span>
          <p>Sélectionnez une tâche à gauche pour voir la solution recommandée.</p>
        </div>
      )
    }

    return (
      <div className="use-case-result fade-in">
        <div className="result-header">
          <span className="result-badge">Outil Recommandé</span>
          <h3 className="result-title">{caseData.tool}</h3>
        </div>
        
        <div className="result-section">
          <h4 className="result-section-title">Pourquoi ce choix ?</h4>
          <p className="result-why glass-card">{caseData.why}</p>
        </div>

        <div className="result-section">
          <h4 className="result-section-title">
            <span className="prompt-icon">💡</span>
            Exemple de Prompt à copier
          </h4>
          <div className="prompt-box">
            {caseData.prompt}
          </div>
        </div>
      </div>
    )
  }

  const renderIASelection = () => {
    const selectedIAData = iaGeneralistes.find(ia => ia.id === selectedIA)
    
    return (
      <div className="ia-selection-container glass-card">
        <div className="ia-selector">
          <label htmlFor="iaSelector" className="selector-label">Sélectionnez une IA pour voir ses avantages et inconvénients :</label>
          <select 
            id="iaSelector" 
            className="ia-selector-dropdown"
            value={selectedIA}
            onChange={(e) => setSelectedIA(e.target.value)}
          >
            <option value="none" disabled>Choisir une IA...</option>
            {iaGeneralistes.map(ia => (
              <option key={ia.id} value={ia.id}>{ia.name}</option>
            ))}
          </select>
        </div>

        {selectedIAData && (
          <div className="ia-details fade-in">
            <div className="ia-details-header">
              <h3 className="ia-details-title">{selectedIAData.name}</h3>
              <div className="ia-details-meta">
                <span className="ia-meta-tag">{selectedIAData.polyvalence}</span>
              </div>
            </div>

            <p className="ia-details-description">{selectedIAData.description}</p>

            <div className="ia-forfaits-section">
              <h4 className="forfaits-title">
                <span className="forfaits-icon">💰</span>
                Forfaits par utilisation
              </h4>
              <div className="forfaits-grid">
                {selectedIAData.forfaits.map((forfait, index) => (
                  <div key={index} className="forfait-card">
                    <div className="forfait-header">
                      <span className="forfait-nom">{forfait.nom}</span>
                      <span className="forfait-prix">{forfait.prix}</span>
                    </div>
                    <p className="forfait-description">{forfait.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="ia-details-grid">
              <div className="ia-details-column">
                <h4 className="ia-details-column-title">
                  <span className="column-icon">✅</span>
                  Avantages
                </h4>
                <ul className="ia-details-list avantages-list">
                  {selectedIAData.avantages.map((avantage, index) => (
                    <li key={index} className="ia-details-item">{avantage}</li>
                  ))}
                </ul>
              </div>

              <div className="ia-details-column">
                <h4 className="ia-details-column-title">
                  <span className="column-icon">⚠️</span>
                  Inconvénients
                </h4>
                <ul className="ia-details-list inconvenients-list">
                  {selectedIAData.inconvenients.map((inconvenient, index) => (
                    <li key={index} className="ia-details-item">{inconvenient}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="ia-details-usage">
              <h4 className="usage-title">Environnement idéal</h4>
              <p className="usage-text">{selectedIAData.usageIdeal}</p>
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="analyse-data-page">
      {/* Page Header with Navigation */}
      <header className="page-header">
        <div className="page-nav">
          <Link to="/" className="back-link">
            <span className="back-arrow">←</span>
            Retour au portfolio
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="page-main">
        <div className="section-inner">
          <div className="section-header">
            <div className="section-label">
              <span>SYNTHÈSE</span> PROFESSIONNELLE
            </div>
            <h1 className="section-title">
              L'Intelligence Artificielle au service de votre <span className="gradient-text">Productivité</span>
            </h1>
            <p className="section-desc">
              En 2026, l'intelligence artificielle générative est devenue un levier concret de productivité pour les entreprises. Elle automatise des tâches répétitives, accélère la rédaction, améliore l'analyse documentaire et assiste les équipes dans le code, la bureautique et la création de contenu.
            </p>
          </div>

          {/* Vue d'ensemble */}
          <div className="vue-overview-section">
            <div className="overview-header">
              <h2 className="overview-title">Vue d'ensemble</h2>
              <p className="overview-desc">
                Le choix d'une IA en 2026 ne se limite plus à "la plus intelligente" : il faut comparer la polyvalence, la sécurité, le coût, l'intégration avec l'environnement de travail et la capacité à traiter des données sensibles.
              </p>
            </div>

            <div className="charts-grid">
              <div className="chart-card glass-card">
                <div className="chart-title-with-help">
                  <h3 className="chart-title">Matrice Complexité vs Impact</h3>
                  <div className="help-tooltip">
                    <span className="help-button">?</span>
                    <div className="tooltip-content">
                      <h4>Comment lire cette matrice ?</h4>
                      <p><strong>Axe X (Complexité)</strong> : Difficulté de mise en œuvre (0 = simple prompt, 10 = intégration API complexe)</p>
                      <p><strong>Axe Y (Impact)</strong> : Gain de temps/argent (0 = faible impact, 10 = impact très élevé)</p>
                      <p><strong>Quick Wins (vert)</strong> : Faible complexité, fort impact → À prioriser en premier</p>
                      <p><strong>Investissements Stratégiques (orange)</strong> : Forte complexité, fort impact → Projets à moyen terme</p>
                      <p><strong>Quick Fixes (gris)</strong> : Faible complexité, faible impact → Améliorations rapides</p>
                    </div>
                  </div>
                </div>
                <p className="chart-subtitle">Priorisez les projets IA par retour sur investissement</p>
                <div className="chart-container">
                  <canvas ref={chartRefs.complexityImpact}></canvas>
                </div>
              </div>
              
              <div className="chart-card glass-card">
                <h3 className="chart-title">Radar des Compétences IA</h3>
                <p className="chart-subtitle">Comparaison des capacités cognitives des grands modèles</p>
                <div className="chart-container radar-container">
                  <canvas ref={chartRefs.radarSkills}></canvas>
                </div>
              </div>
            </div>
          </div>

          {/* IA Selection Section */}
          <div className="ia-selection-section">
            <div className="ia-selection-header">
              <h2 className="ia-selection-title">Analyse Comparative des IA</h2>
              <p className="ia-selection-desc">
                Sélectionnez une IA pour découvrir en détail ses avantages, inconvénients et environnement d'utilisation idéal.
              </p>
            </div>
            {renderIASelection()}
          </div>

          {/* Explorer Section */}
          <div className="explorer-section">
            <div className="explorer-header">
              <h2 className="explorer-title">Explorer les Solutions IA</h2>
              <p className="explorer-desc">
                Découvrez les différentes catégories d'IA et trouvez la solution adaptée à vos besoins spécifiques.
              </p>
            </div>

            <div className="explorer-container glass-card">
              <div className="category-tabs">
                <button
                  className={`category-tab ${activeTab === 'generalistes' ? 'active' : ''}`}
                  onClick={() => setActiveTab('generalistes')}
                >
                  <span className="tab-icon">🤖</span>
                  <span className="tab-label">IA Généralistes</span>
                </button>
                <button
                  className={`category-tab ${activeTab === 'specialisees' ? 'active' : ''}`}
                  onClick={() => setActiveTab('specialisees')}
                >
                  <span className="tab-icon">🎯</span>
                  <span className="tab-label">IA Spécialisées</span>
                </button>
                <button
                  className={`category-tab ${activeTab === 'locales' ? 'active' : ''}`}
                  onClick={() => setActiveTab('locales')}
                >
                  <span className="tab-icon">🔒</span>
                  <span className="tab-label">Solutions Locales</span>
                </button>
                <button
                  className={`category-tab ${activeTab === 'excel' ? 'active' : ''}`}
                  onClick={() => setActiveTab('excel')}
                >
                  <span className="tab-icon">📊</span>
                  <span className="tab-label">Excel & Bureautique</span>
                </button>
              </div>

              <div className="category-content-wrapper">
                {renderCategoryContent()}
              </div>
            </div>
          </div>

          {/* Recommandations par profil d'entreprise */}
          <div className="recommandations-section">
            <div className="recommandations-header">
              <h2 className="recommandations-title">Recommandations par Profil d'Entreprise</h2>
              <p className="recommandations-desc">
                Trois scénarios stratégiques selon le type d'organisation et les priorités métier.
              </p>
            </div>

            <div className="recommandations-grid">
              {recommandationsEntreprise.map((rec, index) => (
                <div key={index} className="recommandation-card glass-card">
                  <div className="recommandation-header">
                    <span className="recommandation-badge">{rec.profil}</span>
                    <h3 className="recommandation-title">{rec.recommandation}</h3>
                  </div>
                  <p className="recommandation-desc">{rec.description}</p>
                  <div className="recommandation-raisons">
                    {rec.raisons.map((raison, i) => (
                      <span key={i} className="raison-tag">{raison}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Classement pratique */}
          <div className="classement-section">
            <div className="classement-header">
              <h2 className="classement-title">Classement Pratique</h2>
              <p className="classement-desc">
                Les meilleurs choix selon les critères spécifiques d'entreprise.
              </p>
            </div>

            <div className="classement-list">
              {classementPratique.map((item, index) => (
                <div key={index} className="classement-item glass-card">
                  <div className="classement-rank">
                    <span className="rank-number">{index + 1}</span>
                    <div className="rank-content">
                      <h4 className="rank-category">{item.categorie}</h4>
                      <p className="rank-vainqueur">
                        <span className="vainqueur-badge">{item.vainqueur}</span>
                      </p>
                      <p className="rank-description">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Use Cases Section */}
          <div className="usecases-section">
            <div className="usecases-header">
              <h2 className="usecases-title">Guide Pratique : Cas d'Usage</h2>
              <p className="usecases-desc">
                Sélectionnez votre objectif professionnel pour obtenir une recommandation d'outil et la marche à suivre.
              </p>
            </div>

            <div className="usecase-container glass-card">
              <div className="usecase-selector">
                <label htmlFor="taskSelector" className="selector-label">Je souhaite...</label>
                <select 
                  id="taskSelector" 
                  className="task-selector"
                  value={selectedUseCase}
                  onChange={(e) => setSelectedUseCase(e.target.value)}
                >
                  <option value="none" disabled>Sélectionnez un objectif...</option>
                  <option value="synthesize">Synthétiser un long document</option>
                  <option value="email">Rédiger un email délicat/commercial</option>
                  <option value="data">Analyser des données Excel/CSV</option>
                  <option value="presentation">Générer une structure de présentation</option>
                  <option value="code">M'aider à coder ou débugger</option>
                  <option value="image">Créer un visuel d'illustration</option>
                </select>
              </div>

              <div className="usecase-result-container">
                {renderUseCaseResult()}
              </div>
            </div>
          </div>

          {/* Recommandation finale */}
          <div className="final-recommandation-section">
            <div className="final-recommandation glass-card">
              <h2 className="final-title">Recommandation Stratégique Finale</h2>
              <div className="final-scenarios">
                <div className="scenario-item">
                  <h3>Polyvalence maximale</h3>
                  <p><strong>ChatGPT</strong> pour une entreprise qui veut une seule IA capable de couvrir la rédaction, l'analyse, le code, les idées et la création de contenus variés.</p>
                </div>
                <div className="scenario-item">
                  <h3>Intégration bureautique</h3>
                  <p><strong>Microsoft 365 Copilot</strong> pour une entreprise très dépendante d'Excel et Microsoft 365 afin de maximiser l'adoption par les collaborateurs.</p>
                </div>
                <div className="scenario-item">
                  <h3>Confidentialité et souveraineté</h3>
                  <p><strong>Architecture locale avec modèles open source</strong> ou <strong>Mistral Enterprise</strong> pour une entreprise soumise à de fortes contraintes de confidentialité.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Page Footer */}
      <footer className="page-footer">
        <div className="section-inner">
          <p>Synthèse professionnelle des IA accessibles en 2026 pour les entreprises.</p>
          <Link to="/" className="footer-link">Retour au portfolio</Link>
        </div>
      </footer>
    </div>
  )
}
